import { useEffect } from "react";

interface ToastProps {
  message: string;
  onClose: () => void;
}

export default function Toast({ message, onClose }: ToastProps) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 2600);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[70] px-4 w-full max-w-sm">
      <div className="flex items-center gap-2.5 rounded-lg bg-primary-950 text-background-50 px-4 py-3 shadow-none border border-primary-800 animate-fadeUp">
        <i className="ri-checkbox-circle-fill text-accent-400"></i>
        <p className="text-xs flex-1">{message}</p>
        <button type="button" onClick={onClose} className="text-primary-400 hover:text-background-50 cursor-pointer" aria-label="关闭提示">
          <i className="ri-close-line"></i>
        </button>
      </div>
    </div>
  );
}